import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white text-center py-4 w-full">
      <p className="text-lg">Thank You For Visiting My Profile <span role="img" aria-label="Heart">❤️</span><span role="img" aria-label="Folded Hands">🙏</span></p>
    </footer>
  );
};

export default Footer;
